import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/site';

export default function CategoryGrid() {
  const getCategoryCount = (slug: string) =>
    articles.filter((a) => a.category === slug).length;

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
          分类浏览
        </h2>
        <span className="w-12 h-0.5 bg-primary-500 flex-1 ml-4 hidden sm:block"></span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300/50 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors">
              <i className={`${cat.icon} text-xl text-primary-600`}></i>
            </div>
            <div className="text-center">
              <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
                {getCategoryCount(cat.slug)} 篇爆料
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}